import { render, staticRenderFns } from "./AddPromo.vue?vue&type=template&id=a2464d8a&"
import script from "./AddPromo.vue?vue&type=script&lang=js&"
export * from "./AddPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports